<template>
  <a-config-provider :locale="enUS" global>
    <router-view></router-view>
  </a-config-provider>
</template>
<script setup lang="ts">
import { computed, ref, watch, onMounted, onUnmounted } from 'vue';
import enUS from '@arco-design/web-vue/es/locale/lang/en-us';
import useStore from '@/store';

// 导入语言包
import zhCn from '@arco-design/web-vue/es/locale/lang/zh-cn';
import en from '@arco-design/web-vue/es/locale/lang/en-us';
import pt from '@arco-design/web-vue/es/locale/lang/pt-pt';
import ru from '@arco-design/web-vue/es/locale/lang/ru-ru';
import { debounce } from './utils/common';

// 语言包map
const languageMap = {
  'zh-cn': zhCn,
  en: en,
  pt: pt,
  ru: ru
};

const { app, setting, user } = useStore();


const language = computed(() => app.language);
const size: any = computed(() => app.size);

const locale = ref();
watch(
  language,
  value => {
    locale.value = languageMap[value as keyof typeof languageMap];
  },
  {
    // 初始化立即执行
    immediate: true
  }
);
console.log(window, 'window.ethereum3');
setting.getWebConfig();
setting.getEnPaymentMethods();

//写个监听窗口变化 debounce 也加上

//如果当前设备是手机先刷新页面然后跳转到手机 /mobile/index 否则先刷新跳转至pc/client/main  如果路由上带有admin 则不进行跳转

// 防抖函数
const debounce = (fn: Function, delay: number) => {
  let timer: any = null;
  return function (...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};

// 判断是否为移动设备
const isMobile = () => {
  return window.innerWidth <= 768;
};
let userRouter = useRouter();
let userRoute = useRoute();

// 处理路由跳转
const handleRouteRedirect = () => {
  const currentPath = userRoute.path;

  // 如果当前路径包含 admin，不进行跳转
  if (currentPath.includes('admin') || currentPath.includes('login') || currentPath.includes('pay')) return;

  // 刷新页面并跳转
  if (isMobile()) {
    //判断是不是mobile 有就不跳转
    if (userRoute.path.includes('mobile')) {
      return;
    }
    userRouter.push('/mobile/index');
  } else {
    if (currentPath.includes('cashRegister')) {
      let params = userRoute.params;
      userRouter.push(`/pay?preOrderId=${params.preOrderId}&order_no=${params.order_no}&amount=${params.amount}&invite_code=${params.invite_code}&bot=${params.bot}`);
      return;
    }
    //判断是不是pc 有就不跳转
    if (currentPath.includes('client')) {
      return;
    }
    userRouter.push('/client/main');
  }
};
watch(userRoute, (value) => {
  if (value.query.promotion_code) {
    user.setPromotionCode(value.query.promotion_code as string || '');
  }
  if (value.query.bot) {
    user.setBot(value.query.bot as string || '');
  }
  if (value.path.includes('admin') || value.path.includes('login') || value.path.includes('pay')) return;
  handleRouteRedirect();
});

</script>

<style scoped lang="less"></style>
